const baseUrl: string = process.env.REACT_APP_API_URL || '';

class Users {
    private uri: string;

    constructor(uri: string) {
        this.uri = uri;
    }

    public read = (params: any) => ({
        baseUrl,
        method: 'get',
        params,
        uri: `${this.uri}/list`,
    });

    public readOne = (id: any) => ({
        baseUrl,
        method: 'get',
        uri: `${this.uri}/${id}`,
    });

    public post = (params: any) => ({
        baseUrl,
        method: 'post',
        params,
        uri: '/auth/v1/user',
    });

    public put = (params: any, id: string) => ({
        baseUrl,
        method: 'patch',
        params,
        uri: `/auth/v1/user/${id}`,
    });

    public delete = (id: string) => ({
        baseUrl,
        method: 'delete',
        uri: `${this.uri}/${id}`,
    });

    public updateStatus = (params: any, id: string) => ({
        baseUrl,
        method: 'patch',
        params,
        uri: `${this.uri}/status/${id}`,
    })
}

export default new Users('/profiles/v1');



// WEBPACK FOOTER //
// ./src/libraries/api/user.tsx